import { frontendURL } from '../../../helper/URLHelper';
import DealsKanban from './pages/DealsKanban.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.DEALS,
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/deals'),
    component: DealsKanban,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'deals_dashboard_index',
        component: DealsKanban,
        meta: commonMeta,
      },
    ],
  },
];
